<template>
  <div>
    <div class="detail-info drug-lines">
      <span class="info-title">病房：</span>
      <div class="drug-line">
        <span class="name">急诊手术室</span>
        <el-input
          v-model="form.number1"
          class="count-input number"
          placeholder="数量"
        />
        <span class="unit">个</span>
        <span class="name">急诊EICU</span>
        <el-input
          v-model="form.number2"
          class="count-input number"
          placeholder="数量"
        />
        <span class="unit">个</span>
        <span class="name">急诊综合病房</span>
        <el-input
          v-model="form.number3"
          class="count-input number"
          placeholder="数量"
        />
        <span class="unit">个</span>
      </div>
    </div>
    <div class="detail-info">
      <span class="info-title detail-class">准备内容：</span>
      <el-input
        v-model="form.content"
        class="drug-detail"
        placeholder=""
        type="textarea"
        resize="none"
        :rows="6"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "DrugEdit",
  data() {
    return {
      number: "",
      form: {
        // nobody_hospitalprepares: {},
        content: "",
        number1: "",
        number2: "",
        number3: "",
      },
    };
  },
  computed: {
    ...mapState({
      patient: "showOrEditPatientInfo"
    }),

  },
  watch: {
    patient: {
      handler(val) {
        const { nobody_hospitalprepares } = val;
        let content = "";
        let number1 = 0;
        let number2 = 0;
        let number3 = 0;
        if (nobody_hospitalprepares.length) {
          const { rooms } = nobody_hospitalprepares[0];
          try {
            const jsonRoom = JSON.parse(rooms);
            number1 = jsonRoom.find(item => item.name === "急诊手术室")?.amount;
            number2 = jsonRoom.find(item => item.name === "急诊EICU")?.amount;
            number3 = jsonRoom.find(item => item.name === "急诊综合病房")?.amount;
          } catch (e) {
            console.log(e);
          }
          content = nobody_hospitalprepares[0].content || "";
        }
        this.form = { content, number1, number2, number3 };
      },
      immediate: true
    }
  },
};
</script>

<style scoped lang="scss">
.detail-info {
  height: auto;
}

.drug-line ::v-deep {
  .el-input__inner {
    height: 32px;
    line-height: 32px;
    border-radius: 10px;
  }

  .count-input {
    width: 60px;
    margin-right: 8px;
    margin-left: 12px;
  }

  .unit {
    margin-right: 46px;
  }
}

.drug-lines {
  position: relative;
  display: flex;
  margin-bottom: 12px;
  color: #666666;
  font-size: 16px;
}

.detail-class {
  height: 16px;
  line-height: 16px;
  vertical-align: top;
}

.drug-detail {
  width: 640px;
  border-radius: 10px;
}

</style>
